<template>
	<div>
		<div>
			<app-header></app-header>
			<div class="row page-header">
				<div class="container">
				<img class="header-background-icon" src="../../assets/images/project-wall.png">
				<div class="col-sm-12"><h1 class="page-title">Projects wall</h1></div>
				<div class="col-sm-12"><h6 class="page-sub-title">Find the perfect job for you and your team</h6></div>
				</div>
			</div>
		</div>
		
		<div class="container">
			<!-- Filter -->
			<div class="row filter">
				<div class="col-sm-3">
					<select class="form-control">
						<option>All Categories (4,502)</option>
					</select>
				</div>

				<div class="col-sm-3">	
					<select class="form-control">
						<option>All Industries</option>
					</select>
				</div>

				<div class="col-sm-3">
				   <!--  <input type="text" class="form-control" name="">
				    <i class="fas fa-search"></i> -->

				    <div class="inner-addon right-addon">
			          <i class="fa fa-search"></i>
			          <input type="text" class="form-control" placeholder="Search" />
			        </div>
				</div>

				<div class="col-sm-2"></div>

				<div class="col-sm-1 btn-filter-container">
					<button class="btn btn-filter"><i class="fa fa-sliders-h"></i>&nbsp;Filter</button>
				</div>
			</div>

			<div class="row apllied-filters">
				<div class="col-sm-2">
					<div class="applied-filters-labels">
						Applied filter
					</div>
				</div>

				<div class="col-sm-10">
					<div class="applied-filters-labels">
						<button class="btn btn-outline-default">
							<i class="fa fa-times"></i> &nbsp;Web, Mobile & Software Development</button>
						<button class="btn btn-outline-default">
							<i class="fa fa-times"></i> &nbsp;Leess than 1 month
						</button>
					</div>
				</div>
			</div>

			<div class="row filters-controls">
				<div class="col-sm-6 pull-left"><b>2 projects found</b></div>
				<div class="col-sm-6 pull-right">
					<div class="sort-controls">
						Sort by: 
						<el-dropdown trigger="click" @command="changeDropdown">
							<span class="el-dropdown-link">
	        					<b>{{sortBy}}</b><i class="el-icon-caret-bottom el-icon--right"></i>
	      					</span>

	      					<el-dropdown-menu slot="dropdown" command="test">
	      						<el-dropdown-item command="Price">Price</el-dropdown-item>
	      						<el-dropdown-item command="Newest first">Newest first</el-dropdown-item>
	      					</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<h5>Front end developer needed for HTML, CSS & Design</h5>
					<div class="row">
						<div class="col-sm-2">
							<i class="far fa-clock"></i>
							Posted 2 days ago
						</div>
						
						<div class="col-sm-2">
							<i class="fas fa-flag-checkered"></i>
							Open Job
						</div>
						
						<div class="col-sm-2">
							<i class="fas fa-dollar-sign"></i> Fixed price: <b>150 <i class="fas fa-euro-sign"></i></b>
						</div>
					</div>

					<div class="row">
						<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ac massa sit amet nunc maximus tempus in eget augue. Pellentesque facilisis justo at mauris aliquam tristique. In hac habitasse platea dictumst. Cras non urna in libero sodales sagittis. Etiam sit amet massa justo. Phasellus sed condimentum nisi, id porttitor dui.</p>
					</div>

					<div class="row">
						<button class="btn btn-outline-default">
							Guaranteed payment</button>
						<button class="btn btn-outline-default">
							Logo & Brand identity</button>
						<button class="btn btn-outline-default">
							MySql Programming</button>
					</div>

					<hr>
				</div>
			</div>

			<div class="col-sm-12">
				<h5>Front end developer needed for HTML, CSS & Design</h5>
				<div class="row">
					<div class="col-sm-2">
						<i class="far fa-clock"></i>
						Posted 2 days ago
					</div>
					
					<div class="col-sm-2">
						<i class="fas fa-flag-checkered"></i>
						Open Job
					</div>
					
					<div class="col-sm-2">
						<i class="fas fa-dollar-sign"></i> Fixed price: <b>150 <i class="fas fa-euro-sign"></i></b>
					</div>
				</div>

				<div class="row">
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ac massa sit amet nunc maximus tempus in eget augue. Pellentesque facilisis justo at mauris aliquam tristique. In hac habitasse platea dictumst. Cras non urna in libero sodales sagittis. Etiam sit amet massa justo. Phasellus sed condimentum nisi, id porttitor dui.</p>
				</div>

				<div class="row">
					<button class="btn btn-outline-default">
						Guaranteed payment</button>
					<button class="btn btn-outline-default">
						Logo & Brand identity</button>
					<button class="btn btn-outline-default">
						MySql Programming</button>
				</div>
				<hr>
			</div>
			<div class="row">
				<div class="col-sm-4"></div>
				<div class="col-sm-4 pagination-holder">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="1">
					</el-pagination>
				</div>
				<div class="col-sm-4"></div>
			</div>
			
		</div>

		<div class="row">&nbsp;</div>
		<div class="row">&nbsp;</div>
		<div class="row">&nbsp;</div>

		<footer-actions></footer-actions>
		<app-footer></app-footer>
	</div>

	
</template>

<script type="text/javascript">
import Header from '../Header.vue'
import FooterActions from '../FooterActions.vue'
import Footer from '../Footer.vue'

export default {
	data() {
		return {
			opened : [],
			sortBy: 'Newest first',
			projects : [
				{ 
					name : 'Unbranded Metal', 
					budget : 2000, 
					tribunal : 3, 
					description : 'Velit illum providen', 
					timeframe : '4 weeks', 
					owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1',
					type : ['freelancer', 'teams']
				}, { 
					name : 'Tap of the Gods', 
					budget : 410, 
					tribunal : 3, 
					description : 'Water dispenser', 
					timeframe : '2 weeks', 
					owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1',
					type : ['teams']
				}, { 
					name : 'Practical Frozen', 
					budget : 1501, 
					tribunal : 11, 
					description : '	Aliquam velit rem si', 
					timeframe : '3 weeks',
					owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1',
					type : ['freelancer']
				}, { 
					name : 'Handcrafted Cotton', 
					budget : 2000, 
					tribunal : 3, 
					description : 'Enim ad et id est au', 
					timeframe : '', 
					owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1',
					type : ['freelancer', 'teams']
				}, { 

					name : 'Ergonomic Granite', 
					budget : 8000000, 
					tribunal : 1, 
					description : 'Labore cumque aliqua', 
					timeframe : '6 weeks', 
					owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1' ,
					type : ['freelancer', 'teams']
				}
			]
		}
	},
	methods: {
		showProject(id) {
			console.log('Show project')
			const index = this.opened.indexOf(id);

			console.log(index)
			if (index > -1) {
		      	this.opened.splice(index, 1)
		    } else {
		    	console.log("else")

		      	this.opened.push(id)
		      	console.log(this.opened.includes(id))
		    }
		},
		changeDropdown(command) {
			this.sortBy = command;
		}
	},
	components : {
		footerActions : FooterActions,
		appFooter : Footer,
		appHeader : Header
	}
}
</script>

<style scoped>
@import '../../assets/css/stylesheet.css';

h5 {
	color : #38DCAB;
}

.filter {
	background-color: #E7E5E0;
	margin-top: 2em;
}

select, input {
	margin: 1em;
}

button {
	margin-right: 1em;
}

.apllied-filters {
	background-color: #F3F3F3;
}

.applied-filters-labels {
	margin: 1em;
}

.btn-filter {
	margin-top:1em;
	margin-right: 2em;
	background-color: #38DCAB;
	color: #fff;
}

.sort-controls {
	float: right;
	cursor: pointer;
}

.filters-controls {
	margin:1em;
}

.btn-filter-container {
	padding: 0.1em;
}

.btn-outline-default {
	background-color: #fff;
	border: 1px solid #F3F3F3;
}

.inner-addon .fa {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

.inner-addon {
  position: relative;
}

/* align glyph */
.right-addon .fa { right: 0px; cursor: pointer;}

/* add padding  */
.right-addon input { padding-right: 30px; }

.pagination-holder {
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/projects/ProjectSearch.vue